import { useEffect, useRef } from 'react'
import { X, Sparkle } from '@phosphor-icons/react'

const AUTO_CLOSE_MS = 20_000

/**
 * Banner de bienvenida que aparece encima del editor cuando el user aterriza
 * con un gift script recién generado. Dismissable con X o auto-close a los 20s.
 */
export function GiftScriptBanner({ onDismiss }) {
  const timerRef = useRef(null)

  useEffect(() => {
    timerRef.current = setTimeout(() => onDismiss?.(), AUTO_CLOSE_MS)
    return () => clearTimeout(timerRef.current)
  }, [onDismiss])

  return (
    <div
      className="flex items-start gap-3 px-5 py-3.5 bg-ds-surface border-l-[3px] border-ds-red border-y border-r border-y-ds-border border-r-ds-border"
      role="status"
      aria-live="polite"
    >
      <Sparkle size={18} weight="fill" color="#D42B1E" className="mt-0.5 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="font-display font-bold text-[12px] tracking-[0.08em] uppercase text-ds-text">
          Tu primer guion está listo
        </p>
        <p className="font-sans text-[13px] text-ds-muted leading-[1.55] mt-1">
          Cuesta <span className="text-ds-text font-medium">0 créditos</span> — este iba por la
          casa. Ahora tienes 10 para seguir experimentando. Edítalo, regenera lo que no te cuadre, o
          bórralo si no te sirve.
        </p>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        className="p-1 text-ds-muted hover:text-ds-text transition-colors flex-shrink-0"
        aria-label="Cerrar aviso"
      >
        <X size={16} />
      </button>
    </div>
  )
}
